import React, { useState, Fragment } from 'react';

//import Banner from "react-js-banner";
import { Paper, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { CalendarFilled } from '@ant-design/icons';
//   import LocationOnIcon from '@mui/icons-material/LocationOn';
import PlaceIcon from '@material-ui/icons/Place';

export default () => {
  const [show, hide] = useState(false); // hide the banner
  const [success, change] = React.useState(null);
  
  const Dismiss = () => {
    hide(!show);
  };
  return (
    <Fragment>
      {/*  fetch all banner if current date is valid then showing the banner else not */}
      {show ? (
        <div className='parent-main-container'>
        
        <div className="main-container">
        
          <div className="text">GET TRAINED IN PERSON | LEADING SAFe 5.1</div>
          <div className="text">
            <CalendarFilled /> JAN 28-29, 2023
          </div>
          <div className="text">
              <PlaceIcon style={{ width:"14px" ,height:"14px"}} />
            THE COLONY, TX
          </div>
          <div>
            <button style={{ borderRadius: '10%' }} className=" banner-button ">
              <a
                style={{ color: 'inherit' }}
                target="_blank"
                href="https://american-technology.net/trainings/course-content/LSILT012823"
              >
                ENROLL NOW
              </a>
            </button>
          </div>

          {/* <Button className="text" onClick={Dismiss}>
            x
          </Button> */}
        </div>
        </div>
      ) : null}
    </Fragment>
  );
};
